<script lang="ts">
    import { _, locale, locales } from "svelte-i18n";
    import {
        Alert,
        ButtonDropdown,
        DropdownItem,
        DropdownMenu,
        DropdownToggle,
    } from "sveltestrap";
    let selectedLanguage = $locale;
    let inStorage = false;

    // try to recover settings from local storage first.
    // if that fails use the already sected language from browser settings.
    if (
        typeof window !== "undefined" &&
        window.localStorage.getItem("lang") !== null
    ) {
        selectedLanguage = window.localStorage.getItem("lang");
        locale.set(selectedLanguage);
        inStorage = true;
    } else {
        // try to match to one of the supported languages.
        let i = $locales.findIndex(
            (x) => selectedLanguage.substring(0, 2) === x
        );
        if (i === -1) {
            selectedLanguage = $locales[0];
        } else {
            selectedLanguage = $locales[i];
        }
        locale.set(selectedLanguage);
    }

    function setLocale(ln: string) {
        selectedLanguage = ln;

        locale.set(selectedLanguage);

        if (typeof window !== "undefined") {
            window.localStorage.setItem("lang", selectedLanguage);
            inStorage = true;
        }

        try {
            document.title = $_("title");
        } catch (e) {
            console.error(e);
            // Not yet inited
        }
    }

    let visible = true;
    if (
        typeof window !== "undefined" &&
        window.localStorage.getItem("langAlert") === "false"
    ) {
        visible = false;
    }

    function hideAlert() {
        visible = false;
        window.localStorage.setItem("langAlert", "false");
    }
</script>

<Alert
    color="secondary"
    isOpen={visible}
    toggle={hideAlert}
    class="rounded-0 w-100 mb-0 py-1">
    <div class="container w-100" style="z-index: unset;">
        <div class="row">
            <div class="col-12 g-0">
                <div class="text-center text-sm">
                    {#if inStorage}
                        {$_("language.change")}
                    {:else}
                        {$_("language.set")}
                    {/if}
                    <ButtonDropdown nav inNavbar class="ms-1">
                        <DropdownToggle
                            class="btn-sm text-sm"
                            color="dark"
                            caret>{$_(`language.${selectedLanguage}`)}</DropdownToggle>
                        <DropdownMenu
                            class="no-transitions"
                            style="z-index: 1070; min-width: 5rem;">
                            {#each $locales as ln}
                                <DropdownItem on:click={() => setLocale(ln)}
                                    >{$_(`language.${ln}`)}</DropdownItem>
                            {/each}
                        </DropdownMenu>
                    </ButtonDropdown>
                </div>
            </div>
        </div>
    </div>
</Alert>
